module.exports = __webpack_public_path__ + "static/img/27.f31608b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/canoa-quebrada/27.jpg
// module id = LLAb
// module chunks = 1